<template>
  <div class="card shadow-sm mb-2 border-1 card-address">
    <div class="container">
      <div class="container--left">
        <div class="btn-address location">
          <i class="material-icons">place</i>
        </div>
        <div class="content">
          <h6>{{ location }}</h6>
          <div class="small">{{ userInfo }}</div>
        </div>
      </div>
      <div class="container--rigth">
        <div class="btn-address btn-address--edit" type="button" @click="editAddress()">
          <i class="material-icons">edit</i>
        </div>
        <div class="btn-address btn-address--delete" type="button" @click="deleteAddress()">
          <i class="material-icons">delete</i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    address: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  computed: {
    location() {
      if (!this.address) return '';
      const { ubigeo, address, lot } = this.address;
      return `${ubigeo[0].name}, ${ubigeo[1].name} ${ubigeo[2].name}, ${address} - ${lot}`;
    },
    userInfo() {
      if (!this.address) return '';
      const { firstName, lastName, phone } = this.address;
      return `${firstName} ${lastName} - ${phone}`;
    }
  },
  methods: {
    editAddress() {
      this.$store.commit('setTypeActionModalAddress', 'edit');
      this.$store.commit('setShowModalNewAddress');
    },
    async deleteAddress() {
      const cloneAddress = { ...this.address };
      cloneAddress.status = 0;
      try {
        await this.$store.dispatch('updateUserAddress', cloneAddress);
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>
<style lang="scss">
.card-address {
  .container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 5px 10px;
    cursor: pointer;
    &--left {
      display: flex;
      flex-direction: row;
      align-items: center;
      .location {
        margin-right: 15px !important;
      }
    }
    &--rigth {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }
  .btn-address {
    margin: 0 5px;
    &--edit {
      // color: #ffc107;
      &:hover {
        color: #e0a800;
      }
    }
    &--delete {
      // color: #d02a16;
      &:hover {
        color: #e83924;
      }
    }
  }
}
</style>
